import HelpIcon from 'assets/images/nav/HelpIcon'
import ThanxAIHeader from 'components/AI/ThanxAIHeader'
import useIsThanxAdmin from 'hooks/useIsThanxAdmin'
import { buildTranslate } from 'locales'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import RequestSegmentModal from 'scenes/CampaignCenter/Landing/RequestSegmentModal'
import { selectCurrentMerchant } from 'selectors/merchant'

const t = buildTranslate('segments.ai_builder.header')
const tReq = buildTranslate('thanx_campaigns.requestSegment.modal')

interface AISegmentBuilderHeaderProps {
  onClose: () => void
}

const AISegmentBuilderHeader = ({ onClose }: AISegmentBuilderHeaderProps) => {
  const [showRequestModal, setShowRequestModal] = useState(false)
  const isThanxAdmin = useIsThanxAdmin()
  const merchant = useSelector(selectCurrentMerchant)
  const merchantName = isThanxAdmin ? merchant?.name : undefined

  const helpLink = (
    <button
      type="button"
      onClick={() => setShowRequestModal(true)}
      className="thanx-ai-header__help-text"
    >
      {t('ask_thanx_to_build')}
      <HelpIcon />
    </button>
  )

  return (
    <>
      <ThanxAIHeader
        onClose={onClose}
        cancelText={t('cancel')}
        rightAlignedNavItems={[helpLink]}
        title="SegmentAI"
        merchantName={merchantName}
      />
      <RequestSegmentModal
        title={tReq('title')}
        subtitle={tReq('subtitle')}
        show={showRequestModal}
        onModalClose={() => setShowRequestModal(false)}
      />
    </>
  )
}

export default AISegmentBuilderHeader
